import { InjectionToken } from '@angular/core';

/**
 * API endpoints the audit module talks to. The module never imports the host
 * application's `environment` file — the host supplies this object through
 * `AuditModule.forRoot({ ... })` so the same code drops into BC_Audit_UI and
 * BC_UI without edits.
 */
export interface AuditModuleConfig {
  identityApiUrl: string;
  corporateApiUrl: string;
  invoicingApiUrl: string;
}

export const AUDIT_MODULE_CONFIG = new InjectionToken<AuditModuleConfig>('AUDIT_MODULE_CONFIG', {
  providedIn: 'root',
  factory: (): AuditModuleConfig => ({
    identityApiUrl: '',
    corporateApiUrl: '',
    invoicingApiUrl: '',
  }),
});
